import { useState, useEffect } from 'react';
import HubSpotIcon from '../../../../images/hubspot.png'
import IntercomIcon from '../../../../images/intercom.png'
import Info from "../../../Info";

function CampaignsTableCard({data, integrationName, viewDetail}) {

  const handleIcon = (id) => {
    switch (id) {
      case 'HubSpot':
        return (
          <img className="rounded-full bg-white mr-2" src={HubSpotIcon} width="36" height="36" />
        );
      case 'Intercom':
        return (
          <img className="rounded-full bg-white mr-2" src={IntercomIcon} width="36" height="36" />
        );
      default:
        return (
          <svg className="flex-shrink-0 mr-2 sm:mr-3" width="36" height="36" viewBox="0 0 36 36">
            <circle fill="#24292E" cx="18" cy="18" r="18" />
            <path d="M18 10.2c-4.4 0-8 3.6-8 8 0 3.5 2.3 6.5 5.5 7.6.4.1.5-.2.5-.4V24c-2.2.5-2.7-1-2.7-1-.4-.9-.9-1.2-.9-1.2-.7-.5.1-.5.1-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.3.7.1-.5.3-.9.5-1.1-1.8-.2-3.6-.9-3.6-4 0-.9.3-1.6.8-2.1-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.2.8.6-.2 1.3-.3 2-.3s1.4.1 2 .3c1.5-1 2.2-.8 2.2-.8.4 1.1.2 1.9.1 2.1.5.6.8 1.3.8 2.1 0 3.1-1.9 3.7-3.7 3.9.3.4.6.9.6 1.6v2.2c0 .2.1.5.6.4 3.2-1.1 5.5-4.1 5.5-7.6-.1-4.4-3.7-8-8.1-8z" fill="#FFF" />
          </svg>
        );
    }
  };

  const defaultRow = <tr key="1" role="row">
    <td className="p-2">
      No campaign data found
    </td>
    <td className="p-2">
      <div className="text-center"></div>
    </td>
    <td className="p-2">
      <div className="text-center text-green-500"></div>
    </td>
    <td className="p-2">
      <div className="text-center"></div>
    </td>
    <td className="p-2">
      <div className="text-center text-light-blue-500"></div>
    </td>
  </tr>

  const [rows, setRows] = useState(null);

  useEffect(() => {
    console.log(data)
    OnLoad();
  }, [data, integrationName]);

  function OnLoad() {
    console.log(typeof data)
    if(data!=null)
      setRows(data.map( (item) =>
        <tr key={item.id} role="row" className="cursor-pointer hover:bg-pink-50"
            onClick={(e)=> {
                e.stopPropagation()
                viewDetail(item)
            }}>
          <td className="p-2">
            <div className="flex items-center">
              {handleIcon(integrationName)}
            </div>
          </td>
          {/*<td className="p-2">
            <div className="flex text-left line-clamp-1">{item.date.split(' ')[0]}</div>
          </td>*/}
          <td className="p-2">
            <div className="flex text-left line-clamp-1">{item.subject}</div>
          </td>
          <td className="p-2">
            <div className="flex items-center">
              <div className="text-gray-800 line-clamp-1">{item.fulltext}</div>
            </div>
          </td>
          <td className="p-2">
            <div className="flex text-left line-clamp-1">{item.type}</div>
          </td>
        </tr>
      ));
  }

  return (
    <div className="col-span-full bg-white shadow-1 rounded-sm border
                    border-gray-200 flex flex-col">
      {/*<header className="px-5 py-4 border-b border-gray-100">
        <h2 className="font-semibold text-gray-800">Marketing Campaigns 🚀</h2>
      </header>*/}
      <div className="p-3 flex-initial">

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="table-auto w-full">
            {/* Table header */}
            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
              <tr>
                <th className="p-2">
                  <div className="font-semibold text-left"></div>
                </th>
                <th className="p-2 w-1/6">
                  <div className="font-semibold text-left">Subject Line</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold text-left">Content</div>
                </th>
                <th className="p-2">
                  <div className="font-semibold flex text-left">
                    Similar to
                    <Info className="ml-3 relative" containerClassName="min-w-80 absolute top-0 right-0 bg-pink-400">
                      <p className="text-sm normal-case font-medium text-white text-justify">The <i>type</i> of campaign the content is
                      most similar to. EmPushy makes this inference based on a number of features of the content, such
                      as its topic, tone and referenced entities.</p>
                    </Info>
                  </div>
                </th>
              </tr>
            </thead>
            {/* Table body */}
            <tbody className="text-sm font-medium divide-y divide-gray-100">
              {/* Row */}
              {
                rows==null?defaultRow:rows
              }
            </tbody>
          </table>

        </div>
      </div>
    </div>
  );
}

export default CampaignsTableCard;
